import { render, staticRenderFns } from "./AppLogin.vue?vue&type=template&id=64b0cbf4&scoped=true&"
import script from "./AppLogin.vue?vue&type=script&lang=js&"
export * from "./AppLogin.vue?vue&type=script&lang=js&"
import style0 from "./AppLogin.vue?vue&type=style&index=0&id=64b0cbf4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b0cbf4",
  null
  
)

export default component.exports